import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Footer from "./Footer";

const LoginForm = () => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  // ✅ Already logged in? → Skip login page, go straight to /admin
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isAdminLoggedIn") === "true";
    if (isLoggedIn) {
      navigate("/admin", { replace: true });
    } else {
      setChecking(false);
    }
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validate = () => {
    if (!formData.username) {
      toast.error("Username is required");
      return false;
    }
    if (!formData.password) {
      toast.error("Password is required");
      return false;
    }
    if (formData.password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.dismiss();

    if (!validate()) return;

    const adminUsername = "admin";
    const adminPassword = "admin1234";

    if (
      formData.username === adminUsername &&
      formData.password === adminPassword
    ) {
      localStorage.setItem("isAdminLoggedIn", "true");
      toast.success("Login successful");
      setTimeout(() => navigate("/admin", { replace: true }), 1200);
    } else {
      toast.error("Invalid admin credentials");
    }
  };

  // ✅ Don't flash the login form if already logged in
  if (checking) return null;

  return (
    <div
      className="Login-section contact-section padding-container"
      style={{ background: "white", position: "relative" }}
    >
      <div className="page-wrapper">
        <div className="contact-bg">
          <div className="contact-us-form">
            <div className="contact-text">
              <h1>LOGIN</h1>
              <p>Login to access your admin account</p>
            </div>

            <div className="contact-form">
              <h1>Login</h1>
              <form className="form-data" onSubmit={handleSubmit}>
                <div className="form-username">
                  <label htmlFor="username">Username</label>
                  <input
                    type="text"
                    name="username"
                    id="username"
                    value={formData.username}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-phone password">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    name="password"
                    id="password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                </div>

                <button type="submit" className="form-submit">
                  Login
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;